module.exports = __webpack_public_path__ + "img/india.2ffeeee2.png";